import React, { useState, useEffect, useRef, } from 'react';
import { FormGroup, Label, InputGroup, Input, Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { isEmpty, sortBy, sum, groupBy, get, keyBy, omit, mapValues, } from 'lodash';
import { useDebounce, useToggle, useList, } from 'react-use';
import { toast, } from 'react-toastify';

import okSoundSrc from '../../sounds/ok.mp3';
import ngSoundSrc from '../../sounds/ng.mp3';
import firebase from '../../firebase';
import { getDocumentData } from '../../shared/firebase';
import { isMobile, safePrefix, } from '../../util';
import useFormState from '../hooks/useFormState';
import ProductSelectOptionLabel from '../ProductSelectOptionLabel';
import Field from '../Field';
import { idWithTenant, } from '../../shared/util';
import ListForm from '../ListForm';
import ProgressButton from '../ProgressButton';
import PendingItemForm from '../forms/PendingItemForm';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useDocumentSubscription from '../hooks/useDocumentSubscription';

const { entries, } = Object;
const db = firebase.firestore();
const unknownInventoriesRef = db.collection('unknownInventories');
const tenantsRef = db.collection('tenants');

export default function UnknownPickingModal(props) {
  const { isOpen, tenants, locations, onClickClose, } = props;
  const ngAudioEl = useRef(null);
  const okAudioEl = useRef(null);
  const locationsByKey = keyBy(locations, 'sortKey');
  const tenantsById = keyBy(tenants, 'id');
  const [locationKeyValue, setLocationKeyValue] = useState('');
  const matchedLocation = locationsByKey[locationKeyValue];
  const [unknownBarcodeValue, setUnknownBarcodeValue] = useState('');
  const matchedUnknownInventories = useCollectionSubscription(matchedLocation && unknownInventoriesRef.where('status', '==', 'shelved').where('locationId', '==', matchedLocation.id), [locationKeyValue]);
  const unknownBarcodeInput = useRef(null);
  const playAudio = (audio) => {
    audio.currentTime = 0;
    audio.play();
  };
  useDebounce(async () => {
    if(isEmpty(unknownBarcodeValue)) return;

    setUnknownBarcodeValue('');
    const unknownInventory = sortBy(matchedUnknownInventories, _ => _.createdAt.toDate()).find(_ => _.unknownBarcode === safePrefix(unknownBarcodeValue));
    if(unknownInventory == null) return playAudio(ngAudioEl.current);

    playAudio(okAudioEl.current);
    const { tenantId, receivingRequestId, isNg, productId, } = unknownInventory;
    const receivingRequest = await getDocumentData(tenantsRef.doc(tenantId).collection('receivingRequests').doc(receivingRequestId));
    const batch = db.batch();
    batch.update(unknownInventory.ref, {
      status: 'picked',
      pickedAt: new Date(),
    });
    await batch.commit();
  }, 300, [unknownBarcodeValue]);
  useDebounce(() => {
    if(locationKeyValue) unknownBarcodeInput.current.focus();
  }, 300, [locationKeyValue]);

  return (
    <Modal isOpen={isOpen}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            在庫移動
          </h5>
        </div>
      </div>
      <ModalBody>
        <FormGroup>
          <Label>ロケーション</Label>
          <Input value={locationKeyValue} onChange={_ => setLocationKeyValue(_.target.value)} />
        </FormGroup>
        <FormGroup>
          <Label>不明在庫バーコード</Label>
          <Input innerRef={unknownBarcodeInput} value={unknownBarcodeValue} onChange={_ => setUnknownBarcodeValue(_.target.value)} />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
      <audio src={ngSoundSrc} ref={ngAudioEl} />
      <audio src={okSoundSrc} ref={okAudioEl} />
    </Modal>
  );
};
